import React from 'react';
import { withRouter } from 'react-router'

import { cx } from 'helpers';


const Menu = ({ children }) => (
  <div className={cx('-popover-frame', 'pv2')}>
    {children}
  </div>
);


class MenuRow extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = () => {
    const { onClick, href, link, history } = this.props;

    if (onClick) return onClick();

    if (link) return history.push(link);

    if (href && href.startsWith('mailto')) {
      return window.location.href = href;
    };

    if (href) {
      return window.open(href);
    };
  }

  render() {
    return (
      <div
        className={cx(
          "flex items-center ph3",
          "moa-ff-sans f6 black-70",
          "pointer hover-bg-near-white bg-animate",
        )}
        style={{
          minHeight: '2rem' // h2
        }}
        onClick={this.handleClick}
      >
        {this.props.children}
      </div>
    );
  }
}

Menu.Row = withRouter(MenuRow);


Menu.Divider = (props) => (
  <div className="pl3">
    <hr
      style={{ borderWidth: '1px 0 0 0' }}
      className="mv2 bt b--light-gray"
    />
  </div>
);


export default Menu;



// WEBPACK FOOTER //
// ./src/components/elems/Menu.js